import { SorterResult } from 'antd/lib/table/interface';
import dayjs from 'dayjs';

import { TableWithForm, TitledContainer } from 'components';

import { commonStore } from 'stores';
import { useGetHeaders, useMemoState, useTableSearchParams, useUserRole } from 'hooks';

import { SnapDashboardDto } from 'codegen';

import { columns, fields, getTroubleshooting, handleAllSnapsTableChange } from './lib';

export const Snaps = () => {
  const retailers = commonStore((state) => state.retailers);

  const [sortOrderInfo, setSortOrderInfo] = useMemoState<SorterResult<SnapDashboardDto>>({ field: 'submitTimestamp', order: 'descend' });

  const headers = useGetHeaders();
  const { isAdmin } = useUserRole();

  const tableFormParams = fields(isAdmin, retailers).map(({ name }) => name) as string[];

  const { setSearchParams, defaultTableParams, formInitialValues } = useTableSearchParams({ tableFormParams });

  const {
    submittedTo,
    submittedFrom,
    states: statuses,
    requiresTroubleshooting: trouble,
    ...rest
  } = formInitialValues;

  const states = statuses ? statuses.split(',') : [];
  const submittedDates = submittedTo && submittedFrom ? [dayjs(submittedFrom), dayjs(submittedTo)] : [dayjs().subtract(30, 'day'), dayjs().endOf('day')];
  const requiresTroubleshooting = getTroubleshooting(trouble);

  return (
    <TitledContainer title='Snaps'>
      <TableWithForm
        // table
        withResetButton
        horizontalScroll
        id='all-snaps-table'
        size='small'
        columns={columns(sortOrderInfo)}
        sortDirections={['descend']}
        formInitialValues={{ ...rest, states, requiresTroubleshooting, submittedDates }}
        defaultTableParams={defaultTableParams}
        onTableChange={handleAllSnapsTableChange(headers, setSearchParams, setSortOrderInfo)}
        // form
        fields={fields(isAdmin, retailers)}
        labelCol={{ span: 0 }}
        wrapperCol={{ span: 24 }}
      />
    </TitledContainer>
  );
};
